<template lang='pug'>
.article2-list
  .articleWithThumbnail-item
    .articleWithThumbnail-top
      .articleWithThumbnail-left
        span.articleWithThumbnail-numbering.hide--mobile 0{{ idx }}
        a.articleWithThumbnail-imageLink(
          v-if="comment.thumbnailUrl" 
          :href="comment.url" 
          target="_blank"
          )
          .articleWithThumbnail-image(
            :style="'background-image: url(' + comment.thumbnailUrl +');'"
            )
        a.articleWithThumbnail-imageLink(
          v-else 
          :href="comment.url" 
          target="_blank")
          .articleWithThumbnail-image(
            :style="defaultImage"
            )
      .articleWithThumbnail-right
        a.articleWithThumbnail-thumbnailLink(
          :href="comment.url"
          target="_blank"
          )
          .articleWithThumbnail-title {{ comment.content }}

        .articleWithThumbnail-editButton(
          v-if="isCommentOwner"
          @click="popupAddEditComment = true"
          )
          i.icon-edit
          
    .articleWithThumbnail-bottom
      .articleWithThumbnail-subinformation
        .articleWithThumbnail-topSubinformation.articleWithThumbnail-statusText--withIcon
          span.articleWithThumbnail-status.articleWithThumbnail-status--verified(
            v-if="comment.judgement.id == 1"
            ) {{ '✓' + comment.judgement[$store.state.lang] }}
          span.articleWithThumbnail-status(
            v-else-if="comment.judgement.id == 2"
            ) {{ '✕' + comment.judgement[$store.state.lang] }}
          span.articleWithThumbnail-status(
            v-else-if="comment.judgement.id == 3"
            ) {{ '△' + comment.judgement[$store.state.lang] }}
          span.articleWithThumbnail-status.articleWithThumbnail-status--lack.articleWithThumbnail-statusText--withIcon(
            v-else-if="comment.judgement.id == 4"
            )
              i.icon-lack
              span {{ comment.judgement[$store.state.lang] }}
          span.articleWithThumbnail-status.articleWithThumbnail-status--personal.articleWithThumbnail-statusText--withIcon(
            v-else-if="comment.judgement.id == 5"
            )
              i.icon-personal
              span {{ comment.judgement[$store.state.lang] }}
          span.articleWithThumbnail-text.show--bigScreens {{ staticData.articlePage.partners}}
          span.articleWithThumbnail-text {{ comment.partner.name}}
        .articleWithThumbnail-bottomSubinformation
          span.articleWithThumbnail-text {{ staticData.articlePage.updatedAt }}
          span.articleWithThumbnail-text {{ updatedAtStr }}
      .articleWithThumbnail-buttons
        .articleWithThumbnail-button(
          v-if="isCommentOwner"
          @click="popupReportErrorList = true" 
          :class="isReportNew?'articleWithThumbnail-investigateButton--active':'articleWithThumbnail-investigateButton'")
          .icon-investigate.show--mobileOnly
          span.hide--mobile 查閱回報
        
        .articleWithThumbnail-button.articleWithThumbnail-reportErrorButton(
          v-else
          @click="toggleReportError"
          )
          i.icon-notice.show--mobileOnly
          span.hide--mobile {{ staticData.articlePage.reportError }}
          
        a.articleWithThumbnail-button.articleWithThumbnail-forwardButton(:href="comment.url" target="_blank")
          .icon-forward.show--mobileOnly
          span.hide--mobile {{ staticData.articlePage.linkToArticle }}
  PopupReportError(v-if="popupReportError" @closePopup="toggleReportError" @isSuccess="popupContentText = true" @isError="isError" :commentId="comment.id")
  PopupContentText(v-if="popupContentText" @closePopup="popupContentText = false" :text="['表單已送出，已轉交查核單位。', '感謝您的回報。']")
  PopupAddEditComment(v-if="popupAddEditComment" type='edit' :comment="comment" @closePopup="popupAddEditComment = false" @isSuccess="isSuccess" @isError="isError" :articleId="articleId" sectionText="編輯查核" :commentId="comment.id")
  PopupReportErrorList(v-if="popupReportErrorList" @closePopup="popupReportErrorList = false" @changePage="changePage" :infos="infos" :articleId="articleId" :commentId="comment.id" :totalPages="totalPages" :totalElements="totalElements")
  PopupContentIconText(v-if="popupContentIconText" @closePopup="popupContentIconText = false" :popupSimpleText="popupSimpleText" :iconType="iconType")
</template>
<script>
import PopupReportError from '@/components/popup/popup_report_error.vue'
import PopupReportErrorList from '@/components/popup/popup_report_error_list.vue'
import PopupContentText from '@/components/popup/popup_content_text.vue'
import PopupContentIconText from '@/components/popup/popup_content_icon_text.vue'
import PopupAddEditComment from '@/components/popup/popup_add_edit_comment.vue'
import { login } from "@/plugins/login.js"
import { getDate, getRouteByParam } from '@/plugins/tool.js'
import VClamp from 'vue-clamp'

export default {
  components: {
    VClamp,
    PopupReportError,
    PopupReportErrorList,
    PopupContentText,
    PopupContentIconText,
    PopupAddEditComment
  },
  props: {
    comment: Object,
    staticData: Object,
    idx: Number,
    articleId: Number
  },
  data() {
    let isCommentOwner
    if (this.comment.partner.id == localStorage.getItem(this.$store.state.storageKeys.id)
      && localStorage.getItem(this.$store.state.storageKeys.identity)=='partners'
    )
      isCommentOwner = true
    else isCommentOwner = false
    let date = getDate(this.comment.updatedAt)
    return {
      infos: [],
      popupReportError: false,
      popupContentText: false,
      popupAddEditComment: false,
      popupReportErrorList: false,
      popupContentIconText: false,
      isCommentOwner: isCommentOwner,
      isReportNew: false,
      token: localStorage.getItem(this.$store.state.storageKeys.token),
      iconType: "",
      popupSimpleText: "",
      totalPages: 0,
      totalElements: 0,
      params: {
        'page': 0,
        'size': 10
      },
      updatedAtStr: date.year + '/' + date.month + '/' + date.date + " " + date.hour + ":" + date.minute
    }
  },
  computed: {
    defaultImage() {
      return "background-image: url('" + process.env.VUE_APP_CDN_URL + "/category/fig-link.png');";
    }
  },
  created() {
    if (this.isCommentOwner)
      this.getInfo()
  },
  methods: {
    async getInfo() {
      let route = this.$store.state.URLs.apiPartner + '/comments/' + this.comment.id + '/feedbacks'
      route = getRouteByParam(this.params, route)
      let result = await this.$axios.get(route, {
        headers: {
          "X-Line-Biz-Session": localStorage.getItem(this.$store.state.storageKeys.token),
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      this.infos = Object.values(result.data.content);
      this.totalPages = result.data.totalPages
      this.totalElements = result.data.totalElements
      this.infos.forEach(info => {
        if (info.isNew == true)
          this.isReportNew = true
        let date = getDate(info.createdAt)
        info.createdAtStr = date.year + '/' + date.month + '/' + date.date + " " + date.hour + ":" + date.minute
      })
    },
    toggleReportError() {
      if (this.token == null)
        login(this.$store.state)
      else
        this.popupReportError = !this.popupReportError
    },
    isSuccess() {
      this.popupContentIconText = true
      this.iconType = "complete"
      this.popupSimpleText = "編輯完成"
    },
    isError() {
      this.popupContentIconText = true
      this.iconType = "error"
      this.popupSimpleText = "發生錯誤"
    },
    changePage(page) {
      this.params.page = page - 1
      this.getInfo()
    }
  }
}
</script>
